import React from 'react';

const Step3_Complete = ({ result, onRestart }) => {
  if (!result) return null;

  return (
    <div className="space-y-6">
      <div className={`rounded p-4 border ${result.success ? 'bg-green-50 border-green-200' : 'bg-yellow-50 border-yellow-200'}`}>
        <p className="font-semibold">Segment: {result.segment_name}</p>
        <p className="text-sm">Segment ID: {result.segment_id || 'N/A'}</p>
        <p className="text-sm">Member Count (reported by WATI): {result.member_count ?? 'N/A'}</p>
        {result.error && <p className="text-sm text-red-600 mt-1">{result.error}</p>}
      </div>

      <div className="grid grid-cols-3 gap-4 text-center">
        <div className="border rounded p-3">
          <p className="text-2xl font-bold">{result.total_input}</p>
          <p className="text-sm text-gray-600">Total Input</p>
        </div>
        <div className="border rounded p-3">
          <p className="text-2xl font-bold text-green-600">{result.created_count}</p>
          <p className="text-sm text-gray-600">New Contacts Created</p>
        </div>
        <div className="border rounded p-3">
          <p className="text-2xl font-bold text-gray-600">{result.existed_count}</p>
          <p className="text-sm text-gray-600">Already Existed</p>
        </div>
      </div>

      {result.created_contacts.length > 0 && (
        <div>
          <h4 className="font-semibold mb-2">New Contacts ({result.created_contacts.length})</h4>
          <div className="max-h-64 overflow-y-auto border rounded">
            <table className="w-full text-sm">
              <thead className="sticky top-0 bg-gray-100">
                <tr>
                  <th className="text-left p-2">Phone</th>
                  <th className="text-left p-2">Contact ID</th>
                </tr>
              </thead>
              <tbody>
                {result.created_contacts.map((c) => (
                  <tr key={c.phone} className="border-t">
                    <td className="p-2">{c.phone}</td>
                    <td className="p-2 font-mono text-xs">{c.contact_id || 'N/A'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {result.failed_count > 0 && (
        <div>
          <h4 className="font-semibold mb-2 text-red-600">Failed ({result.failed_count})</h4>
          <ul className="text-sm text-red-600 list-disc list-inside">
            {result.failed_contacts.map((c) => (
              <li key={c.phone}>
                {c.phone}: {c.error}
              </li>
            ))}
          </ul>
        </div>
      )}

      <button className="border px-4 py-2 rounded" onClick={onRestart}>
        Start Over
      </button>
    </div>
  );
};

export default Step3_Complete;
